'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handlers;

exports.default = clusterCache;

var _arrayReduce = require('fast-loops/lib/arrayReduce');

var _arrayReduce2 = _interopRequireDefault(_arrayReduce);

var _objectReduce = require('fast-loops/lib/objectReduce');

var _objectReduce2 = _interopRequireDefault(_objectReduce);

var _applyKeysInOrder = require('./applyKeysInOrder');

var _applyKeysInOrder2 = _interopRequireDefault(_applyKeysInOrder);

var _generateCSSRule = require('./generateCSSRule');

var _generateCSSRule2 = _interopRequireDefault(_generateCSSRule);

var _objectSortByScore = require('./objectSortByScore');

var _objectSortByScore2 = _interopRequireDefault(_objectSortByScore);

var _getRuleScore = require('./getRuleScore');

var _getRuleScore2 = _interopRequireDefault(_getRuleScore);

var _styleTypes = require('./styleTypes');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var handlers = (_handlers = {}, _defineProperty(_handlers, _styleTypes.RULE_TYPE, function (cluster, _ref) {
  var selector = _ref.selector,
      declaration = _ref.declaration,
      support = _ref.support,
      media = _ref.media;
  var cssRule = (0, _generateCSSRule2.default)(selector, declaration);

  if (support) {
    if (media) {
      if (!cluster.supportMediaRules[media]) {
        cluster.supportMediaRules[media] = {};
      }

      if (!cluster.supportMediaRules[media][support]) {
        cluster.supportMediaRules[media][support] = '';
      }

      cluster.supportMediaRules[media][support] += cssRule;
    } else {
      if (!cluster.supportRules[support]) {
        cluster.supportRules[support] = '';
      }

      cluster.supportRules[support] += cssRule;
    }
  } else if (media) {
    if (!cluster.mediaRules[media]) {
      cluster.mediaRules[media] = '';
    }

    cluster.mediaRules[media] += cssRule;
  } else {
    cluster.rules += cssRule;
  }
}), _defineProperty(_handlers, _styleTypes.FONT_TYPE, function (cluster, _ref2) {
  var fontFace = _ref2.fontFace;
  cluster.fontFaces += fontFace;
}), _defineProperty(_handlers, _styleTypes.KEYFRAME_TYPE, function (cluster, _ref3) {
  var keyframe = _ref3.keyframe;
  cluster.keyframes += keyframe;
}), _defineProperty(_handlers, _styleTypes.STATIC_TYPE, function (cluster, _ref4) {
  var css = _ref4.css,
      selector = _ref4.selector;

  if (selector) {
    cluster.statics += (0, _generateCSSRule2.default)(selector, css);
  } else {
    cluster.statics += css;
  }
}), _handlers);

function clusterCache(cache) {
  var mediaQueryOrder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var supportQueryOrder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var ruleOrder = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var sortedCache = (0, _objectSortByScore2.default)(cache, function (value) {
    return (0, _getRuleScore2.default)(ruleOrder, value.pseudo);
  });
  var mediaRules = (0, _applyKeysInOrder2.default)(mediaQueryOrder);
  var supportRules = (0, _applyKeysInOrder2.default)(supportQueryOrder);
  var supportMediaRules = (0, _arrayReduce2.default)(mediaQueryOrder, function (resultSupportRules, media) {
    resultSupportRules[media] = (0, _applyKeysInOrder2.default)(supportQueryOrder);
    return resultSupportRules;
  }, (0, _applyKeysInOrder2.default)(mediaQueryOrder, {}));
  return (0, _objectReduce2.default)(sortedCache, function (cluster, entry) {
    var handler = handlers[entry.type];

    if (handler) {
      handler(cluster, entry);
    }

    return cluster;
  }, {
    mediaRules: mediaRules,
    supportRules: supportRules,
    supportMediaRules: supportMediaRules,
    fontFaces: '',
    statics: '',
    keyframes: '',
    rules: ''
  });
}